import React, { useState } from "react";

export function Accordion({ children }) {
  return <div className="divide-y divide-gray-200">{children}</div>;
}

export function AccordionItem({ value, children }) {
  return <div className="py-2">{children}</div>;
}

export function AccordionTrigger({ children }) {
  const [open, setOpen] = useState(false);
  return (
    <div onClick={() => setOpen(!open)} className="cursor-pointer font-semibold">
      {children}
    </div>
  );
}

export function AccordionContent({ children }) {
  const [open, setOpen] = useState(false);
  return <div className="text-gray-600 mt-2">{children}</div>;
}
